import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/AccountCircle": AccountCircle, "@mui/material/Switch": Switch, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/FormGroup": FormGroup, "@mui/material/MenuItem": MenuItem, "@mui/material/Menu": Menu } } });
export default ClientProvider;
